import React from 'react';

import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';

import { IconButton, InputAdornment } from 'components';

import { styled } from 'third-party';

const StyledInputAdornment = styled(InputAdornment)`
  position: absolute;
  right: 3rem;
`;

const ClearButton = styled(IconButton)`
  svg {
    padding: 0.2rem;
    width: 0.6em;
    height: 0.6em;
  }
  &:disabled {
    opacity: 0;
  }
`;

type Props = {
  disabled: boolean;
  onClearClick: (event: React.MouseEvent<HTMLElement>) => void;
};

export const IntegrationClearButton: React.FC<Props> = ({
  disabled,
  onClearClick,
}) => (
  <StyledInputAdornment position="end">
    <ClearButton disabled={disabled} onClick={onClearClick}>
      <ClearOutlinedIcon />
    </ClearButton>
  </StyledInputAdornment>
);
